import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import MarketingFooter from "./MarketingFooter";
import MarketingHeader from "./MarketingHeader";
import { ValidateUserProfile } from "../auth/ValidateUserProfile";
import Loader from "../Utils/Loader";
import Alert from "../Utils/Alert";

function MarketingLayout() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const [isLoading, setIsLoading] = useState(true);

  // Simulating a content load delay for demonstration purposes
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // Change this duration as needed

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
    <Alert/>
      <ValidateUserProfile />
      <MarketingHeader />

      {isLoading ? (
        <div className="loader-overlay">
          <Loader />
        </div>
      ) : (
        <>
        <Outlet />
      {!isLoginPage && <MarketingFooter />}
      </>
      )}
    </>
  );
}

export default MarketingLayout;
